import { Heading, Link } from '@thirstycamel/ui'
import { useWindowSize } from '../../pages/hump-club'

export default function HumpClubLandingHero() {
  const isMobile = useWindowSize()

  return (
    <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
      <img
        src={
          isMobile
            ? '/static/images/hump-club-landing/banner_mobile.jpg'
            : '/static/images/hump-club-landing/banner_desktop.jpg'
        }
        alt="Hump Club Banner"
      />
      <div
        style={{
          position: 'absolute',
          top: isMobile ? '66%' : '58%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          color: 'white',
          zIndex: 1,
          width: '100%',
          padding: '0 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="hump-club-landing-heading">Welcome to Hump Club Rewards</div>
        <div className="hump-club-subheading">Join now and unlock your member only perks!</div>
        <div
          style={{
            display: 'flex',
            gap: isMobile ? '10px' : '20px',
            justifyContent: 'center',
            flexWrap: 'wrap',
            width: '100%',
            maxWidth: 'auto',
          }}
        >
          <Link href="/register" _hover={{ textDecoration: 'none' }} style={{ width: 'auto' }}>
            <button className="hump-club-button">Join Now</button>
          </Link>
          <Link
            href="/account/offers"
            _hover={{ textDecoration: 'none' }}
            style={{ width: 'auto' }}
          >
            <button className="hump-club-button">Log In</button>
          </Link>
        </div>
      </div>
      <img
        src={
          isMobile
            ? '/static/images/hump-club-landing/waves2_mobile.png'
            : '/static/images/hump-club-landing/waves2_desktop.png'
        }
        alt="Hump Club Rewards"
      />
    </div>
  )
}
